import MessageApi from '../../../../api/inbox/message';

export default {
  async editMessageContent(_, { conversationId, messageId, content }) {
    await MessageApi.editContent(conversationId, messageId, content);
  },
  async toggleMessageReaction(_, { conversationId, messageId, emoji }) {
    await MessageApi.toggleReaction(conversationId, messageId, emoji);
  },
};
